// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { ErrorHandler, inject, Pipe, PipeTransform } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import moment from 'moment';
import { CtsGantryTimeZoneService } from '../services/cts-gantry-time-zone.service';
import { SettingsService } from '../../shared/services/settings.service';

@Pipe({
  name: 'ctsGantryTimezone',
  pure: false,
  standalone: true,
})
export class CtsGantryTimezonePipe implements PipeTransform {
  private readonly errorHandler = inject(ErrorHandler);
  private readonly settingsService = inject(SettingsService);
  private readonly timeZoneService = inject(CtsGantryTimeZoneService);

  private readonly timeZone = toSignal(this.timeZoneService.timeZone());
  private readonly settingsFormat = toSignal(this.settingsService.dateFormat$);

  private readonly DEFAULT_FORMAT = 'YYYY-DD-MM';

  transform(timestamp: string, offsetInMinutes = 0, fallback = '-'): string {
    let result = fallback;
    try {
      const offset = this.timeZone()?.offsetInMinutes ?? offsetInMinutes;
      const longFormat = `${this.settingsFormat()?.longFormat.toUpperCase() ?? this.DEFAULT_FORMAT} HH:mm:ss`;

      result = moment(timestamp).utcOffset(offset).format(longFormat);
    } catch (error) {
      this.errorHandler.handleError(error);
    }

    return result;
  }
}
